import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { utils } from "~/utils";

const UserMenuItems = ({ onLogout, user }) => (
    <>
        {utils.user_has_perm(user, "view_alert") && (
            <Link to="/notification/" className="dropdown-item btn">
                <i className="fas fa-bell" /> Notification Alerts
            </Link>
        )}
        <button className="dropdown-item btn" onClick={onLogout}>
            <i className="fas fa-power-off" /> Logout
        </button>
    </>
);

const mapStateToProps = store => ({
    user: store.auth.user
});

export default connect(mapStateToProps)(UserMenuItems);
